<template>
    <div class="not-found">
        <img :src="require(`@/assets/icons/${imageName}`)" />
        <p class="not-found-text">{{  text }}</p>
        <p> {{ subtitle }}</p>
        <div class="cta mt-4" :class="{twoButtons: cta1 && cta2}">
            <button @click="$emit('ctaMessage', 'cta1')">{{ cta1 }}</button>
            <button @click="$emit('ctaMessage', 'cta2')">{{ cta2 }}</button>
        </div>
    </div>
</template>
<script setup lang="ts">
import { defineProps, defineEmits } from 'vue';

defineProps<{
    imageName: string,
    text: string,
    subtitle: string,
    cta1?: string,
    cta2?: string
}>()

defineEmits(['ctaMessage']);

    
</script>
<style lang="scss" scoped>
    .not-found {
        display: flex;
        align-items: center;
        flex-direction: column;
        img {
            width: 254px;
        }
        .not-found-text {
            text-transform: uppercase;
            font-weight: 800;
            color: #000;
            font-size: 2rem;
        }
        p {
            font-size: 1.2rem;
            font-weight: 400;
            color: $grey;
        }
    }
    .cta {
        display: flex;
        > button {
            border: 2px solid #000;
            padding: 0.5rem;
            border-radius: 6px;
            text-transform: uppercase;
            font-weight: 500;
            width: 180px;
            margin: 1rem;
        }

    }
</style>